import { render, staticRenderFns } from "./PartnerAcceptPage.vue?vue&type=template&id=03180f42&"
import script from "./PartnerAcceptPage.vue?vue&type=script&lang=js&"
export * from "./PartnerAcceptPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports